import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KozDokumentStavka } from './koz-dokument-stavka';

@Component({
  selector: 'yt-koz-dokument-stavka-modal-update',
  templateUrl: './koz-dokument-stavka-modal-update.component.html'
})

export class KozDokumentStavkaModalUpdateComponent extends BaseModalUpdateComponent<KozDokumentStavka> {

  constructor(
    protected modalContainerService: ModalContainerService<KozDokumentStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
){
    super(modalContainerService, activeModal,modalService);
}


  

}

